/* istanbul ignore file */
import { useState } from 'react';
import axios from 'axios';

const useDownloadFile = (url, title = '', type = 'text/plain') => {
  // Valid statuses are ['idle', 'loading', 'error']
  const [status, setStatus] = useState('idle');

  const downloadFile = async () => {
    try {
      setStatus('loading');
      const res = await axios.get(
        `/api/proxy/downloadFile?url=${encodeURIComponent(url)}`,
        {
          responseType: 'blob',
        }
      );

      // Create invisible anchor tag with download attr from blog
      const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type }));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = downloadUrl;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
      setStatus('idle');

      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error downloading file', err);
      setStatus('error');
    }
  };

  return { status, downloadFile };
};

export default useDownloadFile;
